import React, { useState, useEffect } from 'react'
import { getRequest } from '../../globalhelper/helper'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'

const Organization_Search = props => {
  const [formData, setFormData] = useState({})
  const [showtable, setShowtable] = useState(false)
  const [showError, setShowError] = useState(false)
  const [warning] = useState('Please select atleast one field')
  const [tableData, setTableData] = useState([])
  const [companies, setCompanies] = useState([])
  const [companyDetails, setCompanyDetails] = useState([])
  const [redirect, setRedirect] = useState(false)
  const [SearchJSON, setSearchJSON] = useState([])

  useEffect(() => {
    localStorage.setItem('pageName', 'Search Organization Master')

    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        const responseData = _.sortBy(typeof response.res.data === 'string' ? JSON.parse(response.res.data) : response.res.data, 'Organization Name')
        const companies = responseData.map(item => ({
          orgname: item['Organization Name'],
          orgid: item['Organization ID']
        }))
        console.log(responseData);

        if (companies?.length === 1) {
          setFormData(companies[0]);
        }
        setCompanies(_.sortBy(companies, 'orgname'))
        setCompanyDetails(responseData)
      })
      .catch(err => console.log(err))
  }, [])
  const handleReset = () => {
    setShowtable(false)
    setShowError(false)
    setFormData({})
  }

  const handleSearch = () => {
    if (formData.orgid) {
      getRequest(
        `api/edureka/getOrganizationSearchData?id=${formData.orgid}&name=${formData.orgname}`
      ).then(res => {
        if (res.res.status === 'success') {
          let temp = JSON.parse(res.res.data)

          setTableData(temp)
          setShowtable(true)
          setShowError(false)
        } else {
          console.log('No Data')
        }
      })
    } else {
      setShowError(true)
    }
  }

  const handleOrg = i => {
    const orgid = i['Organization ID'];
    localStorage.setItem('api', `api/edureka/getUpdatedDataFromDB`);
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": { "OrgID": "NoLDE", "Organization ID": orgid, },
      "Module": localStorage.getItem('module'),
      "screenName": "OrganizationMaster"
    }))
    window.open(`/Dynamic_Forms?token=OrganizationMaster&action=edit&orgId=${orgid}&docId=${orgid}`, '_blank');

    // getRequest(`api/edureka/getOrgMasterUpdatedJSON?orgid=${orgid}`)
    //   .then(res => {
    //     if (res.res.status === 'success') {
    //       try {
    //         const data =
    //           typeof res.res.data === 'string'
    //             ? JSON.parse(res.res.data)
    //             : res.res.data
    //         setSearchJSON(data)
    //         if (data.length) {
    //           setRedirect(true)
    //         }
    //       } catch (e) {
    //         console.error('Failed to parse response data:', e)
    //       }
    //     }
    //   })
    //   .catch(err => console.error('API error:', err))
  }

  const onBack = () => {
    setRedirect(false)
    setSearchJSON([])
  }

  if (redirect) {
    return (
      <VR2_Forms
        screenName={'OrganizationMaster'}
        screenAction={'edit'}
        From_SearchJSON={SearchJSON}
        onBack={onBack}
      />
    )
  }


  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography variant='h6'>Search Organization</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xl={4}>
              <Autocomplete
                disablePortal
                options={companies}
                getOptionLabel={companies => companies?.orgname || ''}
                getOptionKey={companies => companies?.orgid || ''}
                onChange={(e, newValue) => setFormData(newValue)}
                value={formData || ''}
                renderInput={params => (
                  <TextField
                    size='small'
                    {...params}
                    name='organizationname'
                    label='Organization Name'
                  />
                )}
              />
            </Grid>
            <Grid item xl={1}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                style={{ marginLeft: 10 }}
                variant='contained'
                color='error'
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                style={{ marginLeft: 10 }}
                variant='contained'
                color='warning'
                onClick={() => props.onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <br />

      {showtable && tableData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell>Organization ID</TableCell>
                <TableCell>Organization Name</TableCell>
                <TableCell>Organization Type</TableCell>
                <TableCell>GST Treatment</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Organization Group</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData
                .sort((a, b) =>
                  a['Organization ID'].localeCompare(b['Organization ID'])
                )
                .map((item, index) => {
                  return (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <Button
                          variant='text'
                          color='primary'
                          onClick={() => handleOrg(item)}
                        >
                          {item['Organization ID']}
                        </Button>
                      </TableCell>
                      <TableCell>{item['Organization Name']}</TableCell>
                      <TableCell>{item['Organization Type']}</TableCell>
                      <TableCell>{item['GST Treatment']}</TableCell>
                      <TableCell>{item['Status']}</TableCell>
                      <TableCell>{item['Organization Group']}</TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}

      {showError && <div className='center-screen'>{warning}</div>}
    </>
  )
}

export default Organization_Search